module.exports = __webpack_public_path__ + "static/tab-nav-mobile-bg-40ec8b82ae8b25521c10707b0a4f1128.svg";